export default __webpack_public_path__ + "static/media/folder_special.959b41cf.svg";